// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/received.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Channel } from "./base_pb.js";
import { ReceivedMessage as ReceivedMessage$1 } from "../../wsevent/chat/v1/message_pb.js";
import { ReceivedTypingIndicator } from "../../wsevent/chat/v1/typing_indicator_pb.js";
import { ReceivedRoomInfo } from "../../wsevent/chat/v1/room_pb.js";
import { ReceivedPost } from "../../wsevent/stream/v1/post_pb.js";
import { ReceivedPost as ReceivedPost$1 } from "../../wsevent/research/v1/post_pb.js";

/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedMessage
 */
export const ReceivedMessage = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedMessage",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(ReceivedMessage_Type) },
    { no: 2, name: "body", kind: "message", T: Body },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.ReceivedMessage.Type
 */
export const ReceivedMessage_Type = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.ReceivedMessage.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_PING", localName: "PING"},
    {no: 2, name: "TYPE_SUBSCRIBE", localName: "SUBSCRIBE"},
    {no: 3, name: "TYPE_UNSUBSCRIBE", localName: "UNSUBSCRIBE"},
    {no: 4, name: "TYPE_BROADCAST", localName: "BROADCAST"},
    {no: 5, name: "TYPE_ERROR", localName: "ERROR"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Body
 */
export const Body = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.Body",
  () => [
    { no: 1, name: "ping", kind: "message", T: Ping, oneof: "body" },
    { no: 2, name: "subscription", kind: "message", T: Subscription, oneof: "body" },
    { no: 3, name: "event", kind: "message", T: ReceivedEvent, oneof: "body" },
    { no: 4, name: "error", kind: "message", T: Error, oneof: "body" },
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Ping
 */
export const Ping = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.Ping",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(Ping_PingStatus) },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.Ping.PingStatus
 */
export const Ping_PingStatus = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.Ping.PingStatus",
  [
    {no: 0, name: "PING_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PING_STATUS_OK", localName: "OK"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Subscription
 */
export const Subscription = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.Subscription",
  () => [
    { no: 1, name: "channel", kind: "message", T: Channel },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(Subscription_Status) },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.Subscription.Status
 */
export const Subscription_Status = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.Subscription.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_SUBSCRIBED", localName: "SUBSCRIBED"},
    {no: 2, name: "STATUS_UNSUBSCRIBED", localName: "UNSUBSCRIBED"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedEvent
 */
export const ReceivedEvent = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedEvent",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(ReceivedEvent_Type) },
    { no: 2, name: "data", kind: "message", T: ReceivedEvent_Data },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.ReceivedEvent.Type
 */
export const ReceivedEvent_Type = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.ReceivedEvent.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_CHAT_MESSAGE", localName: "CHAT_MESSAGE"},
    {no: 2, name: "TYPE_CHAT_TYPING_INDICATOR", localName: "CHAT_TYPING_INDICATOR"},
    {no: 3, name: "TYPE_CHAT_ROOM_INFO", localName: "CHAT_ROOM_INFO"},
    {no: 4, name: "TYPE_STREAM", localName: "STREAM"},
    {no: 5, name: "TYPE_RESEARCH", localName: "RESEARCH"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedEvent.Data
 */
export const ReceivedEvent_Data = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedEvent.Data",
  () => [
    { no: 1, name: "chat_message", kind: "message", T: ReceivedMessage$1, oneof: "data" },
    { no: 2, name: "chat_typing_indicator", kind: "message", T: ReceivedTypingIndicator, oneof: "data" },
    { no: 3, name: "chat_room_info", kind: "message", T: ReceivedRoomInfo, oneof: "data" },
    { no: 4, name: "stream", kind: "message", T: ReceivedPost, oneof: "data" },
    { no: 5, name: "research", kind: "message", T: ReceivedPost$1, oneof: "data" },
  ],
  {localName: "ReceivedEvent_Data"},
);

/**
 * @generated from message social.wssocial.entity.message.v1.Error
 */
export const Error = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.Error",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

